import axiosInstance from '../axiosInterceptor/axiosInstance'

// Fields left out stay as they are.
const updateLivestreamFeatures = async (broadcastId, features, orgId) => {
  const url = `v1/orgs/${orgId}/streams/${broadcastId}/features`
  return axiosInstance.patch(url, features)
}

export default updateLivestreamFeatures
